import { ReportValidationService } from './report-validation.service';

export default angular
  .module('sfMobile.services.reportValidation', [])
  .factory('reportValidationService', ReportValidationService).name;
